import useOnMount from '@/hooks/useOnMount';
import { useSetIntercomIsVisible } from '@/queries/layout.queries';
import QuizletSellScreen from '@/app/components/quizlet/components/sell/quizlet-sell-screen';
import { useGetQuizletResultsV2QuizletResultsGet } from '@/api/generated-catch-backend/quizlet/quizlet';
import useVisitorSession from '@/hooks/useVisitorSession';
import { QuizletVersionConfig } from './quizlet-config';
import { VARS } from '@/app/components/ppra/components/common/constants';

interface QuizletUnifiedResultsProps {
  config: QuizletVersionConfig;
}

export default function QuizletUnifiedResults({ config }: QuizletUnifiedResultsProps) {
  const setIntercomIsVisible = useSetIntercomIsVisible();
  const { sessionToken } = useVisitorSession();
  const { data: quizletResults } = useGetQuizletResultsV2QuizletResultsGet({
    query: { enabled: !!sessionToken }
  });

  // Hide intercom when the component mounts
  useOnMount(() => {
    setIntercomIsVisible.mutate(false);
    return () => {
      setIntercomIsVisible.mutate(true);
    };
  });

  // Always render the sell screen, even if quizletResults is undefined
  // The PersonalizedList component will handle displaying generic marketing messages if needed
  return (
    <QuizletSellScreen
      headline={quizletResults?.goal_headline || `Catch can help you understand your cancer risk`}
      personalizedMessages={quizletResults?.personalized_messages}
      // Removing 2nd header due to wordiness
      //cancerInterestMessage={quizletResults?.cancer_interest_message}
      ctaText={`Join for ${VARS.price.yearly}`}
    />
  );
}